<div class="container" *ngIf="room">
  <div class="header">
    <div class="title">
      {{room.room.name}}
      (<span *ngFor="let participant of participantsToShow; index as i" [pTooltip]="participant.username">{{getParticipantFirstName(participant)}}<span *ngIf="i < participantsToShow.length - 1">, </span>
      </span>
      <span *ngIf="this.room.participants.length >= 4" [pTooltip]="miscParticipantsNames">{{miscParticipants}}</span>)
    </div>
    <p-avatarGroup>
      <p-avatar shape="circle" size="large" *ngFor="let participant of participantsToShow" [style]="{'background-color': 'var(--ui-avatar-background)'}"
                [label]="userService.getAvatarInitial(participant)"
                [image]="userService.getAvatarImage(participant)" [pTooltip]="participant.username"></p-avatar>
      <p-avatar *ngIf="this.room.participants.length >= 4" shape="circle" size="large" [style]="{'background-color': 'var(--ui-avatar-background)'}" [label]="miscParticipants" [pTooltip]="miscParticipantsNames"></p-avatar>
    </p-avatarGroup>
  </div>
  <div class="messages" #messagesElement>
    <div class="message" *ngFor="let message of room.messages">
      <p-avatar class="avatar" shape="circle" size="small" [style]="{'background-color': 'var(--ui-avatar-background)'}"
                [label]="userService.getAvatarInitial(getParticipantFromMessage(message))"
                [image]="userService.getAvatarImage(getParticipantFromMessage(message))" [pTooltip]="getParticipantFromMessage(message).username"></p-avatar>
      <div class="message-content">
        <div class="message-author">{{getParticipantFirstName(getParticipantFromMessage(message))}}</div>
        <div class="message-text">{{message.message}}</div>
      </div>
      <div class="message-time">{{message.creationDate | date:'HH:mm'}}</div>
    </div>
  </div>
  <div class="footer">
    <input type="text" class="message" placeholder="Type a message..." [(ngModel)]="message" (keyup.enter)="sendMessage()">
    <button class="send" type="button" (click)="sendMessage()">Send</button>
  </div>
</div>
